<template>
  <el-form :model="formData" ref="formRef" label-width="80px" class="mt-20px">
    <el-form-item
      label="标记名称"
      prop="Name"
      :rules="[{ required: true, validator: validatorName, trigger: 'blur' }]"
    >
      <el-input v-model="formData.Name" size="small" placeholder="" @change="updateText"></el-input>
    </el-form-item>
    <div class="mb-20px ml-80px">
      <el-button @click="openMode">
        <span v-if="!operatePos">点击标记</span>
        <span v-if="operatePos">取消点击标记</span>
      </el-button>
    </div>

    <el-form-item label="标记坐标" prop="position">
      <el-row :gutter="5">
        <el-col :span="8">
          <el-form-item
            label=""
            prop="XAxial"
            :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
          >
            <el-input
              v-model="formData.XAxial"
              size="small"
              placeholder=""
              @change="posChange()"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label=""
            prop="YAxial"
            :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
          >
            <el-input
              v-model="formData.YAxial"
              size="small"
              placeholder=""
              @change="posChange()"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            label=""
            prop="ZAxial"
            :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
          >
            <el-input
              v-model="formData.ZAxial"
              size="small"
              placeholder=""
              @change="posChange()"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item label="标记描述" prop="Remark">
      <el-input
        :autosize="{ maxRows: 3, minRows: 3 }"
        v-model="formData.Remark"
        resize="none"
        size="small"
        placeholder=""
        type="textarea"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import DiyCodeService from '../../../../service/DiyCodeService'

export default {
  props: ['player', 'cloudRender', 'Id'],
  data() {
    return {
      formData: {
        Remark: null,
        Name: null,
        XAxial: null,
        YAxial: null,
        ZAxial: null,
      },
      operatePos: false,
      picturePtr: null,
      textPtr: null,
      oldName: null,
    }
  },
  computed: {
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  watch: {
    Id(val) {
      this.resSet(val)
    },
  },
  methods: {
    openMode() {
      this.operatePos = !this.operatePos
    },
    posChange() {
      const pos = [this.formData.XAxial, this.formData.YAxial, this.formData.ZAxial]
      if (
        pos.every((o) => {
          return o && /^[+-]?\d+(\.\d+)?$/.test(o)
        })
      ) {
        this.updateMarker(pos)
      }
    },
    async validatorName(rule, value, callback) {
      console.log(value, 'valuevaluevalue')

      if (!value) {
        return callback(new Error('必填属性'))
      }
      if (value === this.oldName) {
        return callback()
      }
      try {
        const [err, res] = await DiyCodeService.GetFormData({
          FormEngineKey: 'diy_3DCoordinationManagement',
          _SearchEqual: {
            Name: value,
          },
        })
        if (!err) {
          if (res.Data) {
            return callback(new Error('名称已存在'))
          }
          return callback()
        }
        return callback(new Error('校验失败，请稍后再试'))
      } catch (e) {
        return callback(new Error('校验失败，请稍后再试'))
      }
    },
    validatorNumber(rule, value, callback) {
      if (!value) {
        return callback(new Error('必填属性'))
      }
      const pattern = /^[+-]?\d+(\.\d+)?$/
      if (pattern.test(value)) {
        return callback()
      }
      return callback(new Error('类型错误'))
    },
    leftCilck(data) {
      if (!this.operatePos) return
      this.formData.XAxial = data.pos[0]
      this.formData.YAxial = data.pos[1]
      this.formData.ZAxial = data.pos[2]
      this.updateMarker(data.pos)
    },
    updateMarker(pos) {
      this.cloudRender.Marker.updateByPicture({
        id: this.picturePtr,
        pos,
        visible: true,
      })

      this.cloudRender.Marker.updateBySingleLine({
        id: this.textPtr,
        pos,
        text: this.formData.Name,
        visible: true,
      })
    },
    async validate() {
      await this.$refs.formRef.validate()
    },
    async getInfo() {
      const param = {
        FormEngineKey: 'diy_3DCoordinationManagement',
        Id: this.Id,
      }
      const [err, res] = await DiyCodeService.GetFormData(param)
      if (!err && res.Code === 1) {
        this.formData = res.Data
        this.oldName = res.Data.Name
      }
    },
    async createTextMarker() {
      const options = {
        pos: this.Id
          ? [this.formData.XAxial, this.formData.YAxial, this.formData.ZAxial]
          : [0, 0, 0],
        background: '#49789e99',
        visible: !!this.Id,
        nodeOffset: [60, -10],
        text: this.Id ? this.formData.Name : '',
        textColor: '#ffffffff',
        markPosType: 4,
      }
      const { data } = await this.cloudRender.Marker.createBySingleLine(options)
      this.textPtr = data[0]
    },
    async createPictureMarker() {
      const options = {
        pos: this.Id
          ? [this.formData.XAxial, this.formData.YAxial, this.formData.ZAxial]
          : [0, 0, 0],
        backgroundUrl: `data://../apps/${this.modelSetting.folderName}/markers/default.png`,
        visible: !!this.Id,
        nodeOffset: [0, 0],
        imgSize: [40, 40],
        markPosType: 4,
      }
      const { data } = await this.cloudRender.Marker.createByPicture(options)
      this.picturePtr = data[0]
    },
    updateText() {
      this.cloudRender.Marker.updateBySingleLine({
        id: this.textPtr,
        text: this.formData.Name,
      })
    },
    async submit() {
      if (this.Id) {
        const param = {
          FormEngineKey: 'diy_3DCoordinationManagement',
          Id: this.Id,
          _RowModel: _.pick(this.formData, ['Id', 'Name', 'XAxial', 'YAxial', 'ZAxial', 'Remark']),
        }
        // eslint-disable-next-line no-return-await
        const [err, res] = await DiyCodeService.uptFormData(param)
        return [err, res, param._RowModel]
      }
      const params = {
        FormEngineKey: 'diy_3DCoordinationManagement',
        _FormData: {
          ...this.formData,
        },
      }
      // eslint-disable-next-line no-return-await
      const [err, res] = await DiyCodeService.addFormData(params)

      return [err, res, params._FormData]
    },
    async resSet(val) {
      this.oldName = null
      if (!val) {
        this.formData = this.$options.data().formData

        this.cloudRender.Marker.updateByPicture({
          id: this.picturePtr,
          visible: true,
        })
        this.cloudRender.Marker.updateBySingleLine({
          id: this.textPtr,
          visible: false,
        })
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate()
        })
        return
      }
      await this.getInfo()
      this.updateMarker([this.formData.XAxial, this.formData.YAxial, this.formData.ZAxial])
    },
  },
  async mounted() {
    this.player.Native.Tools.EventBrowseLClick.connect(this.leftCilck)
    if (this.Id) {
      await this.getInfo()
    }
    this.createPictureMarker()
    this.createTextMarker()
  },
  beforeDestroy() {
    this.player.Native.Tools.EventBrowseLClick.disconnect(this.leftCilck)
    this.cloudRender.Marker.destroyMarker([this.textPtr, this.picturePtr])
  },
}
</script>
<style lang="scss" scoped>
.el-button--default {
  color: #fff !important;
}
</style>
